import React, { Component } from "react";
import { firebaseConnect } from "react-redux-firebase";
import { compose } from "redux";
import { connect } from "react-redux";

import Loading from "./Loading";
import Login from "./Login";
import Dashboard from "./Dashboard";

import "./index.css";

class App extends Component {
  render() {
    const { auth } = this.props;
    if (!auth.isLoaded) return <Loading>Väntar på profil ...</Loading>;
    return auth.isEmpty ? <Login /> : <Dashboard />;
  }
}

export default compose(
  firebaseConnect(), // withFirebase can also be used
  connect(({ firebase: { auth } }) => ({ auth }))
)(App);



// WEBPACK FOOTER //
// ./src/App.js